import { memo, useEffect, useContext, useState } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const Body = memo(() => {
  const { inputs, setInputs, errors, setErrors } = useContext(Data);
  const placeHolderList = {
    ソファについて:
      "ソファサイズ、座り心地などお問い合わせ内容をご記入ください。\nレイアウト関連のご相談の場合には、図面、お写真を添付ください。",
    生地について:
      "生地カラー、生地の特徴についてなど、お問い合わせ内容をご記入ください。\n生地カラー相談をご希望の場合には、お部屋のお写真を添付ください",
    "お届け日・搬入について":
      "お問い合わせ内容をご記入ください\n搬入検証をご希望の方は、図面を添付ください",
    "交換用カバー・付属アイテムなどについて":
      "お問い合わせ内容をご記入ください",
    "ソファ・生地のお手入れについて": "お問い合わせ内容をご記入ください",
    "破損・修理について":
      "お問い合わせ内容をご記入ください\nソファ状態、対象箇所の分かるお写真の添付をお願いいたします。",
    ショールームについて: "お問い合わせ内容をご記入ください",
    法人のお客様: "お問い合わせ内容をご記入ください",
    その他: "お問い合わせ内容をご記入ください",
  };

  const onChange = (e) => {
    setInputs({ ...inputs, body: e.target.value });
    if (e.target.value.length > 0) {
      if (e.target.value.length > 1000) {
        setErrors({ ...errors, body: "*1000文字以内でご入力ください" });
      } else {
        setErrors({ ...errors, body: null });
      }
    } else {
      setErrors({ ...errors, body: "*必須" });
    }
  };

  return (
    <div
      className={styles.formMain}
      style={{ paddingBottom: "50px", borderBottom: "1px solid #D1D1D1" }}
    >
      <h3 className={`en ${styles.headline}`}>
        COMMENT<span>お問い合わせ内容をご入力</span>
      </h3>
      <div>
        <p className="bold">
          お問い合わせ内容
          <span>{errors.body}</span>
        </p>
        <textarea
          name="body"
          placeholder={placeHolderList[inputs.subject]}
          onChange={onChange}
          value={inputs.body}
        ></textarea>
      </div>
    </div>
  );
});

export default Body;
